import React, { Component } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Message } from "semantic-ui-react";
import PropTypes from "prop-types";
import Subscription from "~/models/Subscription/Subscription";
import UiMeet3dPackageInfos from "~/constants/UiMeet3d/UiMeet3dPackageInfos";
import ProviderStatistic from "~/models/Provider/ProviderStatistic";
import CustomerStatistic from "~/models/Customer/CustomerStatistic";
import Link from "~/components/element/Link";
import CommonHelper from "~/utils/CommonHelper";

@observer
class UiMeet3dSubscriptionExceededLimitsMessage extends Component {
  @computed
  get totals() {
    const { subscription } = this.props;

    const totals = {
      leads: 0,
      notifications: 0,
    };

    subscription.nextBillingCycleSubscriptionItems.forEach(item => {
      totals.leads += UiMeet3dPackageInfos[item.otherProductId].leads * item.quantity;
      totals.notifications += UiMeet3dPackageInfos[item.otherProductId].notifications * item.quantity;
    });

    return totals;
  }

  render() {
    const { t, statistic } = this.props;
    const { leads: totalLeads, notifications: totalNotifications } = this.totals;

    if (statistic.uiMeet3dLeadsCount < totalLeads && statistic.uiMeet3dEventNotificationsCount < totalNotifications) {
      return null;
    }

    const items = [];

    if (statistic.uiMeet3dLeadsCount >= totalLeads) {
      items.push(t("clientPanelMisc:leadGenerationLimitReached"));
    }

    if (statistic.uiMeet3dEventNotificationsCount >= totalNotifications) {
      items.push(t("clientPanelMisc:notificationLimitReached"));
    }

    const here = CommonHelper.firstLetterLower(t("here"));
    const ifYouDontWantToBeLimited = CommonHelper.firstLetterLower(t("clientPanelMisc:ifYouDontWantToBeLimited"));

    return (
      <Message warning>
        <Message.Header>{t("clientPanelMisc:limitExceeded")}</Message.Header>
        <p>{t("clientPanelMisc:limitExceededMessage")}:</p>
        <Message.List items={items} />
        <p>
          {t("clientPanelMisc:pleaseUpgradeYourSubscriptionPlan")}{" "}
          <Link to="/billing-central/subscriptions">{here}</Link>, {ifYouDontWantToBeLimited}
        </p>
      </Message>
    );
  }
}

UiMeet3dSubscriptionExceededLimitsMessage.propTypes = {
  t: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
  statistic: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStatistic), PropTypes.instanceOf(CustomerStatistic)]),
};

export default withTranslation()(UiMeet3dSubscriptionExceededLimitsMessage);
